export interface Settings {
  tiltShift: boolean;
  sound: boolean;
  music: boolean;
  /** 0..1, over each one's own level. */
  musicVol: number;
  sfxVol: number;
  quality: 'high' | 'low';
}

const KEY = 'somnhold.settings';
export const isTouch = (): boolean => matchMedia('(pointer: coarse)').matches || 'ontouchstart' in window;
export const isPhone = (): boolean => Math.min(window.innerWidth, window.innerHeight) < 600;

const defaults = (): Settings => ({ tiltShift: !isPhone(), sound: true, music: true, musicVol: 1, sfxVol: 1, quality: isPhone() ? 'low' : 'high' });

const load = (): Settings => {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return { ...defaults(), ...(JSON.parse(raw) as Partial<Settings>) };
  } catch {
    /* storage blocked or corrupt */
  }
  return defaults();
};

export const settings: Settings = load();
// Debug overrides: ?tilt=0, ?quality=low
{
  const q = new URLSearchParams(location.search);
  if (q.get('tilt') === '0') settings.tiltShift = false;
  if (q.get('quality') === 'low' || q.get('quality') === 'high') settings.quality = q.get('quality') as 'low' | 'high';
}
export const saveSettings = (): void => {
  try {
    localStorage.setItem(KEY, JSON.stringify(settings));
  } catch {
    /* ignore */
  }
};
